var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDallelogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFF67",
    d: "M9.333 14.667h5.333V20H9.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A665F5",
    d: "M4 4h5.333v5.333H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.667 9.333H20v5.333h-5.333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#42FEFF",
    d: "M4 9.333h5.333v5.333H4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#51DA4C",
    d: "M9.334 9.333h5.333v5.333H9.334z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#AC7558",
    d: "M4 14.667h5.333V20H4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6E3D",
    d: "M14.667 4H20v5.333h-5.333z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB55F7",
    d: "M14.667 14.667H20V20h-5.333z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C46FF",
    d: "M9.334 4h5.333v5.333H9.334z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDallelogo);
export default __webpack_public_path__ + "static/media/dallelogo.65d9f30c7cc8b3fa4fadafeddcf9f1e8.svg";
export { ForwardRef as ReactComponent };